'use client';

import { useLanguage } from '@/contexts/LanguageContext';
import LegalPageShell from '@/components/legal/LegalPageShell';

export default function PrivacyPage() {
  const { t } = useLanguage();
  const s = t.legal.privacy.sections;

  return (
    <LegalPageShell
      title={t.legal.privacy.title}
      intro={t.legal.privacy.intro}
      sections={[
        s.dataCollected,
        s.purposes,
        s.lawfulBasis,
        s.controllerProcessor,
        s.thirdParties,
        s.dataSharing,
        s.international,
        s.security,
        s.retention,
        s.rights,
        s.cookies,
        s.changes,
      ]}
    />
  );
}
